/**
 *    @author:
 *    @since:
 *
 */
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../../_common/component/IValidator';
import { CanadaAddressComponent} from './canada-address.component';
import { Address } from '../../_common/data/input-data';
import { ViewportScroller } from '@angular/common';

export class CanadaAddressValidation extends IValidator {

     private viewportScroller:ViewportScroller;

     constructor(private component: CanadaAddressComponent) {
           super();
          this.viewportScroller = this.component.viewportScroller;
     }

     private success: boolean;

     public validate(): boolean {

          this.success = true;
          
          if(this.component.addr.chk_international=='Y'){
               return this.success;
          }
            
          //---- [Street Number] ---
          if ( Util.isEmpty(this.component.addr.streetNumber) ) {
               if ( !this.component.isCustodyOtherThanParent )
                     this.focus(this.component.streetNumberID,'input_canadaStreetNumberInput_'+this.component.streetNumberID).error_streetNumber = "contact_info_and_mailing_address.streetNumberEmpty";
          }
          else if ( Util.hasSpecialCharacter(this.component.addr.streetNumber) ) {
               this.focus(this.component.streetNumberID,'input_canadaStreetNumberInput_'+this.component.streetNumberID).error_streetNumber = "contact_info_and_mailing_address.streetNumberInvalid"; 
          }
             
          //---- [Street Name] ---
          if ( Util.isEmpty(this.component.addr.streetName) ) {
               if ( !this.component.isCustodyOtherThanParent )
                     this.focus(this.component.streetNameID,'input_canadaStreetNameInput_'+this.component.streetNameID).error_streetName = "contact_info_and_mailing_address.streetNameEmpty"; 
          }
          else if ( Util.hasSpecialCharacter(this.component.addr.streetName) ) {
               this.focus(this.component.streetNameID,'input_canadaStreetNameInput_'+this.component.streetNameID).error_streetName = "contact_info_and_mailing_address.streetNameInvalid"; 
          }
             
          //---- [Unit] ---
          if ( Util.hasSpecialCharacter(this.component.addr.unit) ) {
               this.focus(this.component.unitID,'input_canadaUnitInput_'+this.component.unitID).error_unit = "contact_info_and_mailing_address.unitNumberInvalid"; 
          }
          
          //---- [Buzzer Code] ---
          if ( Util.hasSpecialCharacter(this.component.addr.buzz ) ) {
               this.focus(this.component.buzzID,'input_canadaBuzzInput_'+this.component.buzzID).error_buzz = "contact_info_and_mailing_address.buzzerCodeInvalid"; 
          }
          
          //---- [City/Town] ---
          if ( Util.isEmpty(this.component.addr.base.city ) ) {
               if ( !this.component.isCustodyOtherThanParent )
                     this.focus(this.component.cityID,'input_canadaCityTownInput_'+this.component.cityID).error_city = "contact_info_and_mailing_address.cityTownEmpty"; 
          }
          else if ( Util.hasSpecialCharacter(this.component.addr.base.city ) ) {
               this.focus(this.component.cityID,'input_canadaCityTownInput_'+this.component.cityID).error_city = "contact_info_and_mailing_address.cityTownInvalid"; 
          }
          
          //---- [Province] ---
          if (  Util.isEmpty(this.component.addr.base.province) ) {
                if ( !this.component.isCustodyOtherThanParent )
                      this.focus(this.component.provinceID,'select_canadaProvinceSelect_'+this.component.provinceID).error_province = "contact_info_and_mailing_address.provinceNotSelected";  
          }
          
          //---- [Postal Code] ---
          if ( Util.isEmpty(this.component.addr.postalCode) ) {
               if ( !this.component.isCustodyOtherThanParent )
                     this.focus(this.component.provinceID,'input_canadaPostalCodeInput_'+this.component.provinceID).error_postal = "contact_info_and_mailing_address.postalCodeEmpty"; 
          }
          else if ( Util.hasSpecialCharacter(this.component.addr.postalCode) ||
                   !Util.postalCodeValidate(this.component.addr.postalCode)) {
                  this.focus(this.component.provinceID,'input_canadaPostalCodeInput_'+this.component.provinceID).error_postal = "contact_info_and_mailing_address.PostalCodeInvalid"; 
          }else{
               this.component.error_postal = '';
          }
             
          if ( Util.isEmpty(this.component.addr.deliveryNeed) ) {
               if ( !this.component.isCustodyOtherThanParent )
                     this.focus('needSD','radio_'+this.component.needSpecialDeliveryID+'_0').error_needSpecialDelivery = "contact_info_and_mailing_address.yesNoEmpty";
          }
            
          if ( this.component.addr.deliveryNeed=='Y' && Util.isEmpty(this.component.addr.deliveryMode) ) {
               if ( !this.component.isCustodyOtherThanParent )
                     this.focus(this.component.deliveryModeID,'radio_specialDelivery_'+this.component.deliveryModeID+'_0').error_selectDeliveryMode = "contact_info_and_mailing_address.deliverModeEmpty";
          }
          
          if(this.component.addr.deliveryMode == 'RR'){
               if ( Util.isEmpty(this.component.addr.deliveryAddr) ) {
                    if ( !this.component.isCustodyOtherThanParent )
                          this.focus(this.component.deliveryModeID,'input_ruralRouteInput').error_deliverAddress_RR = "contact_info_and_mailing_address.rrIDEmpty";
               }
               else if ( Util.hasSpecialCharacter(this.component.addr.deliveryAddr) ) {
                    this.focus(this.component.deliveryModeID,'input_ruralRouteInput').error_deliverAddress_RR = "contact_info_and_mailing_address.rrIDInvalid";
               }else if ( this.component.addr.deliveryAddr.toLowerCase().startsWith("rural route")
                    || this.component.addr.deliveryAddr.toLowerCase().startsWith("rr") 
                    || this.component.addr.deliveryAddr.toLowerCase().startsWith("route rurale") ) {
                    this.focus(this.component.deliveryModeID,'input_ruralRouteInput').error_deliverAddress_RR = "contact_info_and_mailing_address.rrIDWithRR";
               }
          }
          
          if(this.component.addr.deliveryMode == 'MR'){
               if ( Util.isEmpty(this.component.addr.deliveryAddr) ) {
                    if ( !this.component.isCustodyOtherThanParent ) 
                          this.focus(this.component.deliveryModeID,'input_mobileRouteInput').error_deliverAddress_MR = "contact_info_and_mailing_address.mrInfoEmpty";
               }
               else if ( Util.hasSpecialCharacter(this.component.addr.deliveryAddr) ) {
                    this.focus(this.component.deliveryModeID,'input_mobileRouteInput').error_deliverAddress_MR = "contact_info_and_mailing_address.mrInfoInvalid";
               }else if ( this.component.addr.deliveryAddr.toLowerCase().startsWith("mobile route")
                    || this.component.addr.deliveryAddr.toLowerCase().startsWith("mr") 
                    || this.component.addr.deliveryAddr.toLowerCase().startsWith("im")
                    || this.component.addr.deliveryAddr.toLowerCase().startsWith("itinéraire motori")) { //trimmed because size of input text is less than full string.
                    this.focus(this.component.deliveryModeID,'input_mobileRouteInput').error_deliverAddress_MR = "contact_info_and_mailing_address.mrInfoWithMR";
               }
          }
          
          if(this.component.addr.deliveryMode == 'GD'){
               if ( Util.isEmpty(this.component.addr.deliveryAddr) ) {
                    if ( !this.component.isCustodyOtherThanParent )
                          this.focus(this.component.deliveryModeID,'input_generalDeliveryInput').error_deliverAddress_GD = "contact_info_and_mailing_address.gdIDEmpty";
               }
               else if ( Util.hasSpecialCharacter(this.component.addr.deliveryAddr) ) {
                    this.focus(this.component.deliveryModeID,'input_generalDeliveryInput').error_deliverAddress_GD = "contact_info_and_mailing_address.gdIDInvalid";
               }else if ( this.component.addr.deliveryAddr.toLowerCase().startsWith("general delivery")
                    || this.component.addr.deliveryAddr.toLowerCase().startsWith("gd") 
                    || this.component.addr.deliveryAddr.toLowerCase().startsWith("poste restante")
                    || this.component.addr.deliveryAddr.toLowerCase().startsWith("pr")) {
                    this.focus(this.component.deliveryModeID,'input_generalDeliveryInput').error_deliverAddress_GD = "contact_info_and_mailing_address.gdIDWithGD";
               }
          }
            
          if(this.component.addr.deliveryMode == 'PO Box'){
               if ( Util.isEmpty(this.component.addr.deliveryAddr) ) {
                    if ( !this.component.isCustodyOtherThanParent )
                          this.focus(this.component.deliveryModeID,'input_postOfficeBoxInput').error_deliverAddress_POBox = "contact_info_and_mailing_address.poboxEmpty";
               }
               else if ( Util.hasSpecialCharacter(this.component.addr.deliveryAddr) ) {
                    this.focus(this.component.deliveryModeID,'input_postOfficeBoxInput').error_deliverAddress_POBox = "contact_info_and_mailing_address.poboxInvalid";
               }
          }

          return this.success;
     }
       
     private focus(tagId:string,ctrlId:string) : CanadaAddressComponent {
      if ( this.success ) {
           this.viewportScroller.scrollToAnchor(tagId);
           let ctrl = document.getElementById(ctrlId);
           if ( ctrl ) ctrl.focus();
      }
           
      this.success = false;
      return this.component;
    }
}

